import { Inject, Injectable } from '@angular/core';
import { IEntityPageResponse } from '../interfaces/response.interface';
import { StoreService } from '../services/store.service';
import { PaginationParams } from '../ui/components/pagination/pagination.interfaces';
import { PaginationStore } from './pagination-store.service';

export interface ListState<T> {
  rows: T[];
  search?: string;
  loading: boolean;
  filters: Record<
    string,
    string | Record<string, string | undefined> | undefined
  >;
}

@Injectable()
export class EntityListStore<T> extends StoreService<ListState<T>> {
  public readonly paginationStore = new PaginationStore();

  constructor(
    // eslint-disable-next-line @angular-eslint/prefer-inject
    @Inject('FETCH_FN')
    private readonly fetchFn: (
      params: PaginationParams
    ) => Promise<IEntityPageResponse<T>>
  ) {
    super();
    this.setState({
      rows: [],
      search: '',
      filters: {},
      loading: false,
    });
  }

  public async fetch() {
    this.set('loading', true);
    const { data, pagination } = await this.fetchFn({
      limit: this.paginationStore.getLimit(),
      offset: this.paginationStore.getOffset(),
      search: this.select('search')(),
      filters: this.select('filters')(),
    });

    this.set('rows', data);
    this.paginationStore.update(pagination);
    this.set('loading', false);
  }

  public setSearch(search: string) {
    this.set('search', search);
    this.paginationStore.reset();
    this.fetch();
  }

  public getSearch() {
   return this.state().search;
  }
  public setPage(page: number) {
    this.paginationStore.update({ currentPage: page });
    this.fetch();
  }

  public setFilters(
    filters: Record<
      string,
      string | Record<string, string | undefined> | undefined
    >
  ) {
    this.set('filters', {
      ...this.select('filters')(),
      ...filters,
    });
    this.paginationStore.reset();
    this.fetch();
  }
}
